import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import * as Api from "../General/api";

const NameTab = ({ onDoctorsFetched, setIsLoading, resetSignal, initialFirstName, initialLastName }) => {
    const [firstName, setFirstName] = useState(initialFirstName || "");
    const [lastName, setLastName] = useState(initialLastName || "");
    const [infoMsg, setInfoMsg] = useState("");

    // Disable button if either field is empty
    const isButtonDisabled = !firstName.trim() || !lastName.trim();

    useEffect(() => {
        if (initialFirstName) {
            setFirstName(initialFirstName);
        } else {
            setFirstName("");
        }
        if (initialLastName) {
            setLastName(initialLastName);
        } else {
            setLastName("");
        }
        setInfoMsg("");
        if (onDoctorsFetched) onDoctorsFetched([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetSignal, initialFirstName, initialLastName]);

    // Auto-search when initial values are provided on mount
    useEffect(() => {
        if (initialFirstName && initialLastName && resetSignal === "name") {
            const fn = initialFirstName.trim();
            const ln = initialLastName.trim();
            if (fn && ln) {
                const body = { npi: null, firstName: fn, lastName: ln };
                if (setIsLoading) setIsLoading(true);
                Api.postRequest(Api.URI_FetchPhysicianList, body)
                    .then((res) => {
                        const list = res?.data?.result || [];
                        if (res?.data?.success && list.length > 0) {
                            if (onDoctorsFetched) onDoctorsFetched(list);
                            setInfoMsg("");
                        } else {
                            if (onDoctorsFetched) onDoctorsFetched([]);
                            setInfoMsg(res?.data?.message || "No matching records found");
                        }
                    })
                    .catch(() => {
                        setInfoMsg("No matching records found");
                    })
                    .finally(() => {
                        if (setIsLoading) setIsLoading(false);
                    });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialFirstName, initialLastName, resetSignal]);

    const handleNameChange = (e) => {
        const { name, value } = e.target;
        if (/^[A-Za-z ']*$/.test(value)) {
            const cleaned = value.replace(/\s{2,}/g, " ");
            if (name === "firstName") setFirstName(cleaned);
            if (name === "lastName") setLastName(cleaned);
        }
    };

    const handleFocus = () => {
        setInfoMsg("");
        var test = onDoctorsFetched?.([]);
    };

    const handleSearch = async () => {
        const fn = firstName.trim();
        const ln = lastName.trim();

        if (!fn || !ln) return; // just return, button is disabled anyway

        const body = { npi: null, firstName: fn, lastName: ln };

        try {
            var test = setIsLoading?.(true);
            const res = await Api.postRequest(Api.URI_FetchPhysicianList, body);
            const list = res?.data?.result || [];

            if (res?.data?.success && list.length > 0) {
                var test = onDoctorsFetched?.(list);
                setInfoMsg("");
            } else {
                var test = onDoctorsFetched?.([]);
                setInfoMsg(res?.data?.message);
            }
        } catch {
            setInfoMsg("No matching records found");
        } finally {
            var test = setIsLoading?.(false);
        }
    };

    const onKeyDown = (e) => {
        if (e.key === "Enter") handleSearch();
    };

    const fieldWidth = 200;

    return (
        <div className="mx-auto" style={{ maxWidth: 540 }}>
            <div className="d-flex flex-column align-items-center" style={{ gap: 12 }} onKeyDown={onKeyDown}>
                <div className="d-flex align-items-end justify-content-center" style={{ gap: 12 }}>
                    <div style={{ width: fieldWidth }}>
                        <input
                            type="text"
                            name="firstName"
                            className="form-control form-control-sm"
                            value={firstName}
                            onChange={handleNameChange}
                            onFocus={handleFocus}
                            autoComplete="off"
                            placeholder="First Name"
                        />
                    </div>

                    <div style={{ width: fieldWidth }}>
                        <input
                            type="text"
                            name="lastName"
                            className="form-control form-control-sm"
                            value={lastName}
                            onChange={handleNameChange}
                            onFocus={handleFocus}
                            autoComplete="off"
                            placeholder="Last Name"
                        />
                    </div>

                    <div style={{ paddingBottom: 2 }}>
                        <Button
                            type="button"
                            size="sm"
                            variant="primary"
                            onClick={handleSearch}
                            style={{ minWidth: 82 }}
                            disabled={isButtonDisabled} // disables button if either input is empty
                        >
                            Search
                        </Button>
                    </div>
                </div>

                {/* Inline message */}
                {infoMsg && (
                    <div style={{ marginTop: 8, display: "flex", justifyContent: "center", width: "100%" }}>
                        <div
                            role="status"
                            aria-live="polite"
                            style={{
                                display: "inline-flex",
                                alignItems: "flex-start",
                                gap: 4,
                                padding: "4px 8px",
                                borderRadius: 8,
                                backgroundColor: "#FDECEC",
                                border: "1px solid #F4C9C9",
                                color: "#7E1C1C",
                                fontSize: 12,
                                lineHeight: 1.3,
                                fontWeight: 500,
                                letterSpacing: "0.1px",
                                fontFamily: "inherit",
                                boxShadow: "0 1px 2px rgba(0,0,0,.04)",
                                maxWidth: 560,
                            }}
                        >
                            <span aria-hidden="true" style={{ display: "inline-flex", paddingTop: '1px' }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" fill="#FDECEC" stroke="#B43434" strokeWidth="1.8" />
                                    <path d="M12 7.2v7.2" stroke="#B43434" strokeWidth="1.8" strokeLinecap="round" />
                                    <circle cx="12" cy="17.5" r="1.35" fill="#B43434" />
                                </svg>
                            </span>
                            <span style={{ whiteSpace: "normal", textAlign: 'left' }}>{infoMsg}</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NameTab;
